import React from 'react';
import { Bus, Truck, Car } from 'lucide-react';

const AnimatedBackground: React.FC = () => {
  return (
    <div className="fleet-background">
      {/* Grid Pattern */}
      <div className="fleet-background__grid" />
      
      {/* Animated Gradient Orbs */}
      <div className="gradient-orb gradient-orb--1" />
      <div className="gradient-orb gradient-orb--2" />
      <div className="gradient-orb gradient-orb--3" />
      
      {/* Moving Vehicles */}
      <div className="vehicle vehicle--bus" style={{ animationDelay: '0s' }}>
        <Bus className="vehicle__icon" />
      </div>
      
      <div className="vehicle vehicle--truck" style={{ animationDelay: '-10s' }}>
        <Truck className="vehicle__icon" />
      </div>
      
      <div className="vehicle vehicle--van" style={{ animationDelay: '-5s' }}>
        <Car className="vehicle__icon" />
      </div>
      
      {/* Connection Points */}
      <div className="connection-point" style={{ top: '25%', left: '20%' }} />
      <div className="connection-point connection-point--active" style={{ top: '55%', left: '50%' }} />
      <div className="connection-point" style={{ top: '75%', left: '80%' }} />
      <div className="connection-point" style={{ top: '35%', left: '70%' }} />
      
      {/* Floating Particles */}
      <div className="particles-container">
        {Array.from({ length: 15 }).map((_, i) => (
          <div key={i} className="particle" />
        ))}
      </div>
    </div>
  );
};

export default AnimatedBackground;
